import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconChevronTriangleDownSmall"><Path d="M8.75001 10.25C8.46068 10.25 8.19715 10.4164 8.0728 10.6777C7.94846 10.9389 7.98547 11.2484 8.16792 11.4729L11.4179 15.4729C11.5603 15.6482 11.7742 15.75 12 15.75C12.2259 15.75 12.4397 15.6482 12.5821 15.4729L15.8321 11.4729C16.0145 11.2484 16.0516 10.9389 15.9272 10.6777C15.8029 10.4164 15.5393 10.25 15.25 10.25H8.75001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownSmall;
